import { useEffect, useState } from 'react'

import { faCode, faCodeBranch, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'

import { projects } from '../../data/portfolio'
import AnimatedLetters from '../AnimatedLetters'
import ArrowIcon from '../ArrowIcon'
import MiraDemo from '../MiraDemo'
import './index.scss'

const Projects = () => {
  const projectsArray = 'Projects'.split('')
  const [letterClass, setLetterClass] = useState('text-animate')
  const [filter, setFilter] = useState('All')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  // Get unique categories for filtering
  const categories = ['All', ...new Set(projects.map(project => project.category))]

  // Filter projects based on selected category
  const filteredProjects = filter === 'All' 
    ? projects 
    : projects.filter(project => project.category === filter)

  return (
    <>
      <div className="container projects-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={projectsArray}
              idx={15}
            />
          </h1>
          <p>
            Building secure agent execution through Kestrel.
            A look at the authorization controls, backend systems, and automated
            tests behind my current engineering work.
          </p>
          
          {/* Category Filter */}
          <div className="filter-container">
            {categories.map(category => (
              <button
                key={category}
                className={`filter-btn ${filter === category ? 'active' : ''}`}
                onClick={() => setFilter(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        <div className="projects-container">
          <div className="projects-grid">
            {filteredProjects.map((project, index) => (
              <div key={project.id} className={`project-card ${project.id === 'mira' ? 'mira-project-card' : ''}`} style={{animationDelay: `${index * 0.1}s`}}>
                {project.id === 'mira' && <span className="mira-frame-corners" aria-hidden="true"><i /><i /><i /><i /></span>}
                {/* Project Images Section - with provision for multiple images */}
                {project.images && project.images.length > 0 && (
                  <div className="project-images">
                    <div className="image-carousel">
                      {project.images.map((image, idx) => (
                        <img key={idx} src={image} alt={`${project.title} ${idx + 1}`} />
                      ))}
                    </div>
                  </div>
                )}
                
                <div className="project-content">
                  <div className="project-header">
                    <div className="project-meta">
                      <span className="category">{project.category}</span>
                      {project.year && <span className="year">{project.year}</span>}
                      <span className={`status ${project.status.toLowerCase().replaceAll(' ', '-')}`}>
                        {project.status}
                      </span>
                    </div>
                    <div className="mira-title-row">
                      <h3 className="project-title">
                        {project.title}
                      </h3>
                      {project.id === 'mira' && <div className="mira-spatial-mark" aria-hidden="true">
                        <div className="mira-spatial-cube">
                          {['front', 'back', 'right', 'left', 'top', 'bottom'].map(face => <span key={face} className={`mira-face mira-face-${face}`} />)}
                        </div>
                      </div>}
                    </div>
                    {project.company && <p className="company">{project.company}</p>}
                  </div>

                  <p className="project-description">{project.description}</p>

                  <div className="project-features">
                    <h4>Development so far:</h4>
                    <ul>
                      {project.features.map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  </div>

                  <p className="project-description">{project.direction}</p>
                  {project.id === 'mira' && <MiraDemo />}

                  <div className="technologies">
                    {project.technologies.map((tech, idx) => (
                      <span key={idx} className="tech-tag">{tech}</span>
                    ))}
                  </div>

                  <div className="project-links">
                    {project.githubUrl && (
                      <a href={project.githubUrl} target="_blank" rel="noreferrer" className="project-link">
                        <FontAwesomeIcon icon={faCodeBranch} />
                        <span>Code</span>
                      </a>
                    )}
                    {project.liveUrl && (
                      <a href={project.liveUrl} target="_blank" rel="noreferrer" className="project-link">
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                        <span>Live Demo</span>
                      </a>
                    )}
                    {project.isPrivate && (
                      <span className="private-indicator">
                        <FontAwesomeIcon icon={faCode} />
                        <span>Private Project</span>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <section className="arc-demo-invitation" aria-labelledby="arc-invitation-title">
            <span className="eyebrow">INTERACTIVE DEMO</span>
            <h2 id="arc-invitation-title">ARC · The AI Learning System</h2>
            <p>Explore a lesson, a prepared tutor explanation, and a practice question from my learning workspace.</p>
            <Link className="flat-button" to="/demos/arc">EXPLORE ARC <ArrowIcon /></Link>
          </section>
        </div>
      </div>
    </>
  )
}

export default Projects
